import calculatorsApi from '../../config/calculatorsApi'

// Normalized error thrown by runCalculator so callers can branch on `.kind`.
export class CalculatorApiError extends Error {
  constructor(kind, message, status) {
    super(message)
    this.name = 'CalculatorApiError'
    this.kind = kind // 'auth' | 'quota' | 'network' | 'server' | 'unknown'
    this.status = status
  }
}

function classify(error) {
  if (error.response) {
    const status = error.response.status
    if (status === 401 || status === 403)
      return new CalculatorApiError('auth', 'Neispravan ili istekao API ključ.', status)
    if (status === 429)
      return new CalculatorApiError('quota', 'Mesečna kvota je iskorišćena. Pokušaj kasnije.', status)
    if (status >= 500)
      return new CalculatorApiError('server', 'Greška na serveru kalkulatora.', status)
    return new CalculatorApiError(
      'unknown',
      error.response.data?.message || 'Neuspeo zahtev kalkulatora.',
      status
    )
  }
  if (error.request)
    return new CalculatorApiError('network', 'Nema konekcije sa serverom kalkulatora.')
  return new CalculatorApiError('unknown', error.message || 'Nepoznata greška.')
}

/**
 * Run a Betkotip calculator over HTTP.
 *
 * @param {string} category English category slug (e.g. 'predictions', 'odds')
 * @param {string} slug     English calculator slug (e.g. 'boxing')
 * @param {object} body     request body (native Serbian keys pass through translateInput)
 * @returns {Promise<object>} the `data` payload (response is `{ data, meta }`)
 * @throws {CalculatorApiError}
 */
export async function runCalculator(category, slug, body) {
  try {
    const res = await calculatorsApi.post(
      `/v1/calculators/${category}/${slug}`,
      body || {}
    )
    return res.data?.data ?? res.data
  } catch (error) {
    throw classify(error)
  }
}

export default runCalculator
